import { useState } from 'react';
// import './App.css';
// import About from './About';
// import React, { createElement } from 'react';
// import ReactDOM from 'react-dom/client';
import MyNavbar from '../components/MyNavbar';
import TextForm from '../components/TextForm';
import Alerts from '../components/Alerts';
import About from '../pages/About';

function App() {
  const [mode, setMode] = useState("light")
  const [text, setText] = useState("Dark Mode")
  const [btn, setBtn] = useState("secondary")
  const [Alert, setAlert] = useState(null)
  
  const toggleMode = () => {
    if (mode === 'light') {
      setMode("dark")
      setText("Light Mode")
      document.body.style.backgroundColor = '#363d45'
      setBtn("dark")
      ShowAlert("success","Dark Mode Enabled")
    } else {
      setMode("light")
      setText("Dark Mode")
      document.body.style.backgroundColor = 'white'
      setBtn("secondary")
      ShowAlert("success","Light Mode Enabled")
    }
  }
  const ShowAlert = (type, message)=>{
    setAlert({
      tpe: type,
      msg: message
    })
    setTimeout(()=>{
        setAlert(null)
    }, 2000)
    
  }
  return (
    <>
    <MyNavbar title='ChangeText' color='red' modeText={text} textColor={mode} mode={mode} toggleMode={toggleMode} />
    <Alerts Alert={Alert}/> 
    <TextForm mode={mode} buttonType={btn} ShowAlert={ShowAlert}/>
    <About mode={mode}/>
    </>
  );
}

export default App;
